export function normalizeLancamentoPayload(lancamento) {
    return {
        ...lancamento,
        valorOriginal: lancamento.valorOriginal ?? 0,
        valor: lancamento.valor ?? 0,
        valorAberto: lancamento.valorAberto ?? 0,
        descontoPercentual: lancamento.descontoPercentual ?? 0,
        descontoValor: lancamento.descontoValor ?? 0,
        acrescimoPercentual: lancamento.acrescimoPercentual ?? 0,
        acrescimoValor: lancamento.acrescimoValor ?? 0,
        multaPercentual: lancamento.multaPercentual ?? 0,
        multa: lancamento.multa ?? 0,
        jurosPercentual: lancamento.jurosPercentual ?? 0,
        juros: lancamento.juros ?? 0,
    };
}
